// extracted by mini-css-extract-plugin
export default {"container":"FuwgCard_container__LYyj9","wrapper":"FuwgCard_wrapper__xQXzT","image":"FuwgCard_image__qpGcQ","header":"FuwgCard_header__N0MN7"};